import React, { useEffect, useState } from "react";
import {
  footer1,
  footer2,
  footerLogo,
} from "../../assets/images";
import { useTranslation } from "react-i18next";
import axios from "axios";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const [item, setItem] = useState([]);

  const getLocalized = (field) => {
  if (!item) return "";
  return currentLanguage === "en" ? item[`${field}En`] 
       : currentLanguage === "ru" ? item[`${field}Ru`] 
       : item[field];
};

  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    try {
      const response = await axios.get(
        `https://cortex-site.runasp.net/api/Settings`,
        { withCredentials: false }
      );
      console.log(response.data);
      setItem(response.data[0]);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  return (
    <div className="bg-[#F9F9F9] pt-[56px] md:pt-[120px] font-secondFont">
      <div className="bg-[#2a3d63] ">
        <div className="max-w-containerSm md:max-w-container mx-auto">
          <div className="pt-[48px] pb-[22px] flex flex-col items-center text-[white]">
            <img alt="Footer logo" className="w-[204px]" src={footerLogo}></img>
            <p className="mt-[24px] text-center">
              {t("Güclü Təməllər, Yüksək Hədəflər Üçün Çalışırıq!")}
            </p>
            <nav className="flex flex-col md:flex-row gap-4 text-[14px] md:text-[16px] mt-8 text-center">
              <a href={`/${currentLanguage}`}>{t("Ana səhifə")}</a>
              <a href={`/${currentLanguage}`}>{t("Haqqımızda")}</a>
              <a href={`/${currentLanguage}/services`}>{t("Xidmətlər")}</a>
              <a href={`/${currentLanguage}/projects`}>{t("Layihələr")}</a>
              <a href={`/${currentLanguage}/partners`}>{t("Tərəfdaşlıq")}</a>
              <a href={`/${currentLanguage}/blogs`}>{t("Bloq")}</a>
              <a href={`/${currentLanguage}/media`}>{t("Media")}</a>
              <a href={`/${currentLanguage}/contact`}>{t("Əlaqə")}</a>
            </nav>

            <nav className="md:flex gap-8 mt-8">
              <div className="flex gap-2">
                <img alt="Location" className="h-5 w-5" src={footer1}></img>
                <p className="text-[14px]">{getLocalized("location")}</p>
              </div>
              <div className="flex gap-2">
                <img alt="Mobile" className="h-5 w-5" src={footer2}></img>
                <p className="text-[14px]">{item.mobile}</p>
              </div>
            </nav>
            <div className="w-full h-[1px] bg-[#CFCFCF] mt-[56px]"></div>
            <div className="md:flex justify-between text-[14px] mt-5 text-center w-full">
              {/* <p>cortex.az © {t("Bütün hüquqlar qorunur.")}</p> */}
              <p></p>
              <p>{t("Sayt hazırlandı:")} <a target="_blank" href="https://www.birsayt.az">Birsayt.az</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
